import React from 'react';
import {
    Box,
    FormControl,
    FormHelperText,
    Button,
} from '@mui/material';
import UploadComponent from '../common/form/UploadComponent';

const ProductUploadForm = ({ formik }) => {
    return (
        <div>
            <Box
                component="form"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 2,
                    px: 2,
                }}
                noValidate
                autoComplete="off"
                onSubmit={formik.handleSubmit}
            >
                <Box>
                    <UploadComponent formik={formik} />
                    {formik.touched.file && Boolean(formik.errors.file) && (
                        <FormControl error>
                            <FormHelperText>
                                {formik.touched.file && formik.errors.file}
                            </FormHelperText>
                        </FormControl>
                    )}
                </Box>
                <Box sx={{ py: 2 }}>
                    <Button color="primary" variant="contained" type="submit" fullWidth>
                        저장
                    </Button>
                </Box>
            </Box>
        </div>
    );
};

export default ProductUploadForm;
